import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const BillDrill = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'bill');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default BillDrill;
